import React from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import { FaMoneyBillWave, FaCreditCard } from "react-icons/fa";

const PaymentPlans = () => {
  return (
    <Container className="py-5">
      {/* Section Header */}
      <div className="text-center mb-5">
        <h2 className="fw-bold">Payment Options</h2>
        <p className="text-muted">
          Secure and convenient payment methods available at {process.env.REACT_APP_NAME}
        </p>
      </div>

      <Row className="justify-content-center g-4">
        {/* Cash on Delivery */}
        <Col md={5}>
          <Card className="h-100 border-0 shadow-sm text-center">
            <Card.Body className="p-4">
              <FaMoneyBillWave className="text-success fs-1 mb-3" />

              <h5 className="fw-bold">Cash on Delivery</h5>
              <Badge bg="success" className="mb-3">
                Available Nationwide
              </Badge>

              <p className="text-muted">
                Pay in cash when your order is delivered to your doorstep.
                Simple, safe, and trusted by thousands of customers.
              </p>
            </Card.Body>
          </Card>
        </Col>

        {/* Online Payment */}
        <Col md={5}>
          <Card className="h-100 border-0 shadow-sm text-center">
            <Card.Body className="p-4">
              <FaCreditCard className="text-primary fs-1 mb-3" />

              <h5 className="fw-bold">Online Payment</h5>
              <Badge bg="primary" className="mb-3">
                SSLCommerz Secured
              </Badge>

              <p className="text-muted">
                Pay securely using SSLCommerz. Supports bKash, Nagad, Rocket,
                Visa, MasterCard, and Internet Banking.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentPlans;
